import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageModel } from 'src/app/models/common/image.model';
import { SaveCategoryModel } from 'src/app/models/catalog/save-category.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePage } from '../base-page';
import { CategoryTreeItemModel } from 'src/app/models/catalog/category-tree-item.model';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'app-edit-category',
    templateUrl: './edit-category.component.html',
    styleUrls: ['./edit-category.component.scss'],
    standalone: false
})
export class EditCategoryComponent extends BasePage implements OnInit {

  public model: SaveCategoryModel = {
    isPublished: true,
  };

  public categories: Array<CategoryTreeItemModel> = [];

  public constructor(private mApiService: ApiService, private mRouter: Router, activatedRoute: ActivatedRoute, private mMessageService: MessageService) {
    super();

    this.model.id = activatedRoute.snapshot.params['id'] !== 'new' ? activatedRoute.snapshot.params['id'] : undefined;
  }

  ngOnInit(): void {

    if (this.model.id) {
      this.mApiService.get<SaveCategoryModel>(`/api/admin/catalog/category/${this.model.id}`).subscribe({
        next: r => {
          this.model = r;
          this.isBusy = false;
        },
        error: () => {
          this.isBusy = false;
        }
      });
    } else {
      this.isBusy = false;
    }

    this.mApiService.get<Array<CategoryTreeItemModel>>('/api/admin/catalog/category/tree').subscribe(r => {
      this.categories = r;
    });
  }

  public getSelectPrefix(level: number) {
    return ' ' + '-'.repeat(level) + ' ';
  }

  public removeImage() {
    this.model.image = undefined;
  }

  public selectFile(event: any) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    formData.append('order', '1');
    this.isBusy = true;

    this.mApiService.formData<ImageModel>('/api/admin/catalog/image/save', formData).subscribe({
      next: (r) => {
        this.model.image = r;
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public save() {
    this.isBusy = true;

    this.mApiService.post<SaveCategoryModel, SaveCategoryModel>('/api/admin/catalog/category', this.model).subscribe({
      next: r => {
        this.isBusy = false;

        if (!this.model.id) {
          this.mRouter.navigate([`/categories/edit/${r.id}`]);
        }
        this.model = r;

        this.mMessageService.addMessage({
          text: 'Категория сохранена',
          type: this.mMessageService.types.success
        }, true);

      }, error: () => this.isBusy = false
    });
  }

}
